import { Routes, Route, Navigate } from 'react-router-dom';

import Deliveries from '@/Pages/deliveries';

function DeliveriesRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Deliveries />} />

      <Route path="*" element={<Navigate to="/not-found" replace />} />
    </Routes>
  );
}

export default DeliveriesRoutes;
